<template lang="html">
  <div class="about-hero">
    <div class="about-hero-mobile-bg">
      <img src="../../assets/img/about-hero-mobile.svg" alt="">
    </div>
    <div class="about-hero-desktop-bg">
      <img src="../../assets/img/about-hero-desktop-01.svg" alt="">
    </div>
    <div class="about-hero-text">
      <h1>About Us</h1>
    </div>

  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .about-hero {
    min-height: 30vh;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns:  repeat(12, 1fr);
    grid-auto-rows: minmax(.5fr, auto);
  }
  .about-hero-mobile-bg {
    grid-column: 1/13;
    grid-row: 1/13;
    z-index:2;
    margin-top: 3em;
  }
  .about-hero-desktop-bg {
    display: none;
  }
  .about-hero-text {
    padding-top: 1em;
    grid-column: 2/12;
    grid-row:7;
    text-align: left;
    z-index: 3;
  }

  @media (min-width: 768px) {
    .about-hero-mobile-bg {
      display: none;
    }

    .about-hero-desktop-bg {
      display:block;
      grid-column: 1/13;
      grid-row: 1/13;
      z-index:2;
      margin-top: 0;
    }
    .about-hero-text {
      padding-top: 1em;
      grid-column: 4/10;
      grid-row:6;
    }
  }
  @media (min-width: 992px) {
      .about-hero {
        min-height: 50vh;
      }

      .about-hero-text {
        padding-top: 1em;
        grid-column: 4/10;
        grid-row:4/10;
      }
      .about-hero-text h1 {
        font-size: 4rem;
      }
   }
   @media (min-width: 1440px) {
       .about-hero-desktop-bg {
         grid-column: 1/13;
         grid-row: 1/13;
         z-index:2;
       }
       .about-hero-text {
         padding-top: 1em;
         grid-column: 4/10;
         grid-row:6;
       }
       .about-hero-text h1 {
         font-size: 5rem;
       }
    }

</style>
